<template>
  <Partnerships />
</template>

<script setup>
import Partnerships from "~/components/partnership/index.vue";
</script>
